var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUploadCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.93022 7.14303C6.71189 4.17816 9.31742 2 12.4131 2C15.5088 2 18.1143 4.17816 18.896 7.14303C21.2347 7.70961 22.9766 9.89249 22.9766 12.5C22.9766 14.4079 22.0429 16.0883 20.6298 17.0732C20.1891 17.3804 19.5926 17.2574 19.2976 16.7985C19.0026 16.3395 19.1207 15.7184 19.5615 15.4112C20.4646 14.7817 21.056 13.7125 21.056 12.5C21.056 10.6778 19.718 9.17983 18.0099 9.0151C17.5748 8.97314 17.2217 8.63058 17.1508 8.18158C16.7764 5.80967 14.7968 4 12.4131 4C10.0294 4 8.04983 5.80967 7.67537 8.18158C7.60449 8.63058 7.25144 8.97314 6.81633 9.0151C5.10824 9.17983 3.77024 10.6778 3.77024 12.5C3.77024 13.7125 4.36156 14.7817 5.26475 15.4112C5.70549 15.7184 5.82362 16.3395 5.52859 16.7985C5.23357 17.2574 4.63712 17.3804 4.19638 17.0732C2.7833 16.0883 1.84961 14.4079 1.84961 12.5C1.84961 9.89249 3.59153 7.70961 5.93022 7.14303ZM11.4528 14.4142L9.25088 16.7071C8.87585 17.0976 8.26781 17.0976 7.89278 16.7071C7.51776 16.3166 7.51776 15.6834 7.89278 15.2929L11.7341 11.2929C12.1091 10.9024 12.7171 10.9024 13.0921 11.2929L16.9334 15.2929C17.3084 15.6834 17.3084 16.3166 16.9334 16.7071C16.5584 17.0976 15.9504 17.0976 15.5753 16.7071L13.3734 14.4142V21C13.3734 21.5523 12.9435 22 12.4131 22C11.8827 22 11.4528 21.5523 11.4528 21V14.4142Z",
    fill: "#0157FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/upload-cloud.8b8895b302c46b529ed64370693aa427.svg";
export { ForwardRef as ReactComponent };